import { render } from "./KeyMinus.vue?vue&type=template&id=36e5edfe"
import script from "./KeyMinus.vue?vue&type=script&lang=ts"
export * from "./KeyMinus.vue?vue&type=script&lang=ts"
script.render = render

export default script